<template>
	<div class="wc-locations" v-if="locations">
		<div class="wc-locations-title"><BaseCmsLabel code="step_shipping_choose_location" /></div>
		<div class="wc-location-items">
			<div class="wc-location-group" v-for="(key, value) in locations" :key="key">
				<div class="wc-location-group-title">
					<BaseCmsLabel v-if="value == 'true'" code="store_available" tag="div" />
					<BaseCmsLabel v-else code="store_empty_stock" tag="div" class="wc-location-group-title-empty" />
				</div>
				<!-- FIXME labele za adresu, radno vrijeme i prikaži sve -->
				<div class="wc-location-group-items" :class="{'active': showAll[value]}">
					<div class="wc-location" v-for="location in key" :key="location.id">
						<input type="radio" name="location" :id="location.id" :value="location.id" v-model="selectedLocation" @click="updateShipping(location)" />
						<label :for="location.id">{{ location.title }}</label>
						<template v-if="location.id == selectedLocation">	
							<BaseLocationPoint v-slot="{item}" :id="location.id" :seo="false">
								<div class="wc-location-detail">
									<div class="wc-location-detail-item" v-if="item.address">
										<div class="wc-location-detail-title"><BaseCmsLabel code="store_address" /></div>
										<div v-html="item.address" />
									</div>
									<div class="wc-location-detail-item" v-if="item.business_hour">
										<div class="wc-location-detail-title"><BaseCmsLabel code="store_business_hours" /></div>
										<div v-html="item.business_hour" />	
									</div>
									<BaseLocationGoogleMap pin="/images/pin.svg" :locations="[item]" :id="'map'+location.id" :info-window="false" :map-options="{fullscreenControl: false, cameraControl: false}" />
								</div>
							</BaseLocationPoint>
						</template>
					</div>
					<button type="button" v-if="key?.length > 3 && !showAll[value]" class="btn btn-outline show-all" @click="showAll[value] = !showAll[value]"><BaseCmsLabel code="show_all_stores" /></button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const webshop = useWebshop();
	const props = defineProps(['parcel']);
	const {checkoutLoading} = useCheckout();
	const selectedLocation = ref(props.parcel?.shipping?.pickup_location?.selected?.id || null);
	const showAll = ref({});
	const {gtmTrack} = useGtmBB();

	const locations = computed(() => {
		const locationData = props.parcel.shipping.pickup_location.available;
		const locationsGroup = locationData.reduce(function (r, a) {
			r[a.has_stock] = r[a.has_stock] || [];
			r[a.has_stock].push(a);
			return r;
		}, Object.create(null));

		// Create a new ordered object with "true" first, then "false"
		const orderedLocationsGroup = {};
		
		// Add "true" group first if it exists
		if (locationsGroup["true"]) {
			orderedLocationsGroup["true"] = locationsGroup["true"];
		}
		
		// Add "false" group second if it exists
		if (locationsGroup["false"]) {
			orderedLocationsGroup["false"] = locationsGroup["false"];
		}

		return orderedLocationsGroup;
	})


	const {currentlySelectedShipping} = inject('webshopPackageData', {currentlySelectedShipping: null});
	async function updateShipping(location) {
		checkoutLoading.value = true;
		const cartCodes = props.parcel.items.map(el => el.shopping_cart_code);
		const shippingId = currentlySelectedShipping.value?.id;
		if(!shippingId || !location.id || !cartCodes.length) {	
			return console.error('Missing shipping ID, cart codes or selected location');
		}
		
		await webshop.updateShipping({
			shipping_id: shippingId,
			shopping_cart_codes: cartCodes,
			shipping_data: {
				location_point_id: location.id,
			}
		});
		checkoutLoading.value = false;
		gtmTrack('add_shipping_info', {cart: webshop.getCartData(), shippingOption: currentlySelectedShipping.value.code});
	}	
</script>

<style scoped lang="less">
	.wc-locations{
		padding: 40px 100px 0;
		@media (max-width: @l){padding: 20px 70px 0;}
		@media (max-width: @t){padding: 20px 0;}
	}
	.wc-locations-title{
		font-size: 15px; font-weight: bold; padding: 0 0 12px;
		@media (max-width: @m){font-size: 14px;}
	}
	.wc-location-group-title{
		font-weight: bold; padding: 0 0 12px; font-size: 15px; font-weight: normal;
		@media (max-width: @m){font-size: 14px;}
	}
	.wc-location-group-items{
		display: flex; flex-direction: column; gap: 12px;
		.wc-location:nth-child(n+4){display: none;}
		&.active .wc-location{display: block;}
	}
	.wc-location-items{display: flex; flex-direction: column; gap: 25px;}
	input[type=radio]+label{
		font-weight: bold; font-size: 15px;border: 1px solid var(--gray2); padding: 12px; border-radius: 8px; padding: 13px 0 13px 40px;
		&:before{left: 12px; top: 13px;}
	}
	input[type=radio]:checked+label{border-color: var(--blueDark);}
	.wc-location-detail{padding: 24px 12px; font-size: 12px; line-height: 1.5;}
	.wc-location-detail-title{
		font-size: 16px; font-weight: bold; padding: 0 0 10px;
		@media (max-width: @m){font-size: 14px;}
	}
	.wc-location-detail-item{padding: 0 0 12px;}
	.map{height: 200px; margin-top: 15px;}
	.show-all{
		min-width: 260px; align-self: flex-start;
		@media (max-width: @m){padding: 0; border: 0; min-width: 0; font-weight: normal; height: auto; text-decoration: underline; font-size: 12px; color: var(--textColor);}
	}
</style>
